import { render, staticRenderFns } from "./wholeDismantleList.vue?vue&type=template&id=8e0d43a8"
import script from "./wholeDismantleList.vue?vue&type=script&lang=js"
export * from "./wholeDismantleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports